import React, { memo, useEffect } from 'react'
import { RootState } from './stores/store'
import { useDispatch, useSelector } from 'react-redux'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { UserState, viewAsGuest } from './stores/slices/current-user-slice'
import { ApplicationRoutes } from './routes'

type Props = {

}

const LogoutHandler: React.FC<Props> = memo((props: Props) => {
    const currentState = useSelector((state: RootState) => state.user.userState)

    const dispatch = useDispatch()
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if(currentState === UserState.TokenExpired){
            const pathname = location.pathname;
            let redirectTo = '/';
            if (pathname.startsWith(`/${ApplicationRoutes.ADMIN_UTIL_BASE}`)) {
                redirectTo = `/${ApplicationRoutes.ADMIN_UTIL_SECRET}`;
            } else if (pathname.startsWith(`/${ApplicationRoutes.ADMIN_BASE}`)) {
                redirectTo = `/${ApplicationRoutes.ADMIN_SECRET}`;
            }
            navigate(redirectTo, { replace: true });
            dispatch(viewAsGuest())
        }
    }, [currentState, navigate, dispatch, location.pathname])

    return (
        <Outlet />
    )
})

export default LogoutHandler